import React from 'react';
import StripedTableCell from './StripedTableCell';
import StripedTableScrollbarRow from './StripedTableScrollbarRow';

const StripedTableEmptyRow = ({
    id = 'table-row-empty',
    columns = 1,
    border = '1px solid rgb(215,215,215)',
    row = 0,
    cellStyle,
    height = 40,
    ...props
}) => {
    cellStyle = {
        boxSizing: 'border-box',
        height: height,
        maxHeight: height,
        minHeight: height,
        borderRight: border,
        borderBottom: border,
        position: 'relative',
        ...cellStyle
    };

    const generateColumns = () => {
        const cells = [];
        cells.push(
            <StripedTableCell
                key={0}
                index={row}
                style={{
                    borderLeft: border,
                    ...cellStyle
                }}
            />
        );
        for (let i = 1; i < columns; i++) {
            cells.push(
                <StripedTableCell key={i} index={row} style={cellStyle} />
            );
        }
        return cells;
    };

    return (
        <StripedTableScrollbarRow
            {...props}
            id={`${id}-${row}`}
            border={border}
        >
            {generateColumns()}
        </StripedTableScrollbarRow>
    );
};

export default StripedTableEmptyRow;
